/** @format */

import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';

import { CommonDirectiveModule } from '@dcsg-ngx-ecommerce/common/directives/directive.module';
import { CommonModule } from '@angular/common';
import { CommonWidgetsModule } from '@dcsg-ngx-ecommerce/engage/component/common-widgets/common-widgets.module';
import { CtaModule } from '../../cta/cta.module';
import { DcsgNgxEcommerceCommonModule } from '@dcsg-ngx-ecommerce/common';
import { ExclusiveProductPanelModule } from '@shared/components';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { MediaModule } from '@dcsg-ngx-ecommerce/engage/component/media/media.module';
import { StoryV4Component } from './story-v4.component';

@NgModule({
	imports: [
		CommonDirectiveModule,
		CommonModule,
		CommonWidgetsModule,
		CtaModule,
		DcsgNgxEcommerceCommonModule,
		ExclusiveProductPanelModule,
		HmfButtonComponent,
		MediaModule
	],
	declarations: [StoryV4Component],
	exports: [StoryV4Component],
	schemas: [NO_ERRORS_SCHEMA],
	bootstrap: [StoryV4Component]
})
export class StoryV4Module {}
